import * as React from 'react';
export const TransferGlyph = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M25.7979 16L36.1139 32L25.7979 48H38.203L48.519 32L38.203 16H25.7979Z", fill: "var(--color__glyph__accent)" }),
    React.createElement("path", { d: "M27.8954 32L32.0068 25.6172L25.8062 16L15.4902 32L25.8094 48L32.0105 38.3806L27.8954 32Z", fill: "var(--color__glyph__primary)" })));
